/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-underscore-dangle */

const defaultMessages = {
  wrongTool() {
    return 'Не тот инструмент.'
  },
  waitTeammate() {
    return 'Слишком рано. Ваш коллега не завершил предыдущие шаги.'
  },
  wrongRotation() {
    return 'Неправильный угол поворота.'
  },
  wrongState() {
    return 'Неправильное состояние элемента.'
  }
}

export default defaultMessages
